import { Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import {     
    HisFileUploadService,
    HisUploadConfiguration,
    UploadFieldConfigResponse,
    HisGenericValueService,
    HisBackendService, GenericValue } from 'hisng';

@Injectable()
export class DocumentMetadataCategoryService {

    constructor( private backendService: HisBackendService, public fileUploadService: HisFileUploadService, public genericValueService: HisGenericValueService ) { }

    /**
     * load documentMetadataCategoryValue for target object
     *
     * @param target reference object
     */
    public getDocumentMetadataCategories( target: string ): Observable<GenericValue[]> {
        return this.backendService.getData( `api/v1/fs/res/documentMetadataCategories/${target}` ) as Observable<GenericValue[]>;
    }
    

    public getDocumentCategoriesByConfkey( confKey:string ): Observable<GenericValue[]> {
        return this.genericValueService.getValueTypes('documentMetadataCategoryValue')
            .pipe(switchMap(categories => this.fileUploadService.getUploadFieldConfig( confKey, null, null )
                .pipe(map((config: UploadFieldConfigResponse) => {
                    const documentMetadataCategoryIds = new HisUploadConfiguration( config ).getDocumentMetadataCategoryIds();
                    
                    return categories.filter(c => documentMetadataCategoryIds.includes(c.id));
                }))
            ));
    }

}
